import { exportFileFormat } from '../../../utils/ExportFileUtils'
import interceptedAxios from '../../../utils/interceptedAxios'

export async function exportFirmwareCampaignDetailsGrid (
  firmwareCampaignId: string,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/firmwareCampaign/downloadCampaignDetailsById?firmwareCampaignId=${firmwareCampaignId}`
  interceptedAxios
    .get(url, { responseType: 'blob' })
    .then((response) => {
      exportFileFormat(response, 'FirmwareUpgradeDetails_')
      onSuccess(response)
    })
    .catch((error) => {
      onFailure(error)
    })
}
